export const DESKTOP_HARDCODE_LINKS = {
    APPLE: 'https://apps.apple.com/US/app/id1361619409?mt=8',
    GOOGLE: 'https://play.google.com/store/apps/details?id=net.beginners.weight.loss.workout.women.yoga.go',
};

export const FAQ_IOS_CODE = 'ios';
export const FAQ_ANDROID_CODE = 'android';

export const BASE_LINK = 'https://help-centre.yogago.welltech.com';

export const CONTACT_US_LINK = 'https://contact-us.welltech.com/yoga-go.html';
